import { createBaseStore } from '~/app/store'

interface DomesticCartStore {
  /** 선택한(+ 주문 가능한) 장바구니 Option Id Set */
  selectedOptionIds: Set<string>
  /** 단건 선택 */
  selectOption: (optionId: string) => void
  /** 단건 해제 */
  unselectOption: (optionId: string) => void
  /** 다건 해제 (N개 상품 삭제시 사용) */
  unselectOptions: (optionIds: string[]) => void
  /** 전체 선택 - 주문 가능한 option ids 만 전달 */
  selectAllOptions: (optionIds: string[]) => void
  /** 전체 해제 */
  unselectAllOptions: () => void
}

/**
 * 장바구니 Store
 */
const useDomesticCartStore = createBaseStore<DomesticCartStore>(
  set => ({
    selectedOptionIds: new Set<string>(),
    selectOption: (optionId: string) => {
      set(state => ({
        selectedOptionIds: new Set([...state.selectedOptionIds, optionId]),
      }))
    },
    unselectOption: (optionId: string) => {
      set(state => {
        const newSet = new Set(state.selectedOptionIds)
        newSet.delete(optionId)
        return {
          selectedOptionIds: newSet,
        }
      })
    },
    unselectOptions: (optionIds: string[]) => {
      set(state => {
        const newSet = new Set(state.selectedOptionIds)
        optionIds.forEach(id => newSet.delete(id))
        return {
          selectedOptionIds: newSet,
        }
      })
    },
    selectAllOptions: (optionIds: string[]) => {
      set(() => ({
        selectedOptionIds: new Set(optionIds),
      }))
    },
    unselectAllOptions: () => {
      set(() => ({
        selectedOptionIds: new Set<string>(),
      }))
    },
  }),
  {
    name: 'useDomesticCartStore',
  }
)

export default useDomesticCartStore
